var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{ref:"liElement",staticClass:"leuckentext-question-item"},[_c(_setup.HTMLRenderer,{attrs:{"html":_setup.question}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }